export const createStripeIntent = async (email: string, priceId: string) => {
  return fetch("https://charlieosmond.app.n8n.cloud/webhook/setup-intent", {
    method: "POST",
    headers: {'Content-Type': 'application/json'},
    mode: 'cors',
    body: JSON.stringify({priceId, email}),
  })
    .then(r => r.json())
}

export const createStripeSubscription = async (priceId: string, customerId: string, paymentMethodId: string, userId: string) => {
  return fetch("https://charlieosmond.app.n8n.cloud/webhook/create-subscription", {
    method: "POST",
    headers: {'Content-Type': 'application/json'},
    mode: 'cors',
    body: JSON.stringify({priceId, customerId, paymentMethodId, userId}),
  })
}

export const cancelStripeSubscription = async (userId: string) => {
  return fetch("https://charlieosmond.app.n8n.cloud/webhook/cancel-subscription", {
    method: "POST",
    headers: {'Content-Type': 'application/json'},
    mode: 'cors',
    body: JSON.stringify({userId}),
  })
}

